import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '部署了',
    type: 'VR_DEPLOYED_ON',
}
